<template>
  <van-popup v-model="openModal" @click-overlay="maskClicked">
    <div class="wrapper">
      <h3 class="header">请确认是否删除该项目？</h3>
      <div class="item">
        <div class="assertive">特别提醒</div>
        <p>指当前年龄段，满足您身体最基本检查的体检项目，一般不建议删除！</p>
      </div>
      <div class="item">
        <div>检查意义</div>
        <p>{{ project.inspectionSignificance || '无' }}</p>
      </div>
    </div>
    <ul class="btns">
      <li>
        <button class="close" @click.stop="iconClicked(false)">再看看</button>
      </li>
      <li>
        <button class="del" @click.stop="iconClicked(true)">确认删除</button>
      </li>
    </ul>

  </van-popup>
</template>

<script>
import {Popup} from 'vant'
import Vue from 'vue'

Vue.use(Popup)
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    project: {
      type: Object,
      default: {}
    }
  },
  computed: {
    openModal: {
      get: function () {
        return this.showModal
      },
      set: function (v) {
        return !this.showModal
      }
    }
  },
  methods: {
    maskClicked (e) {
      this.$emit('maskClicked', e)
    },
    iconClicked (close) {
      this.$emit('iconClicked', close)
    }
  },
  name: 'projectDel'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
@import "@/assets/style/variables.scss";

.van-popup {
  border-radius: 10px;
}

.wrapper {
  width: 320px;
  padding: 20px;
}

.header {
  border-bottom: 1px solid #DDDDDD;
  line-height: 50px;
  padding-bottom: 15px;
  margin-bottom: 20px;
  text-align: center;
}

.item {
  padding-bottom: 18px;

  div {
    font-size: 14px;
    font-weight: bold;
    padding-bottom: 6px;
  }

  p {
    font-size: 14px;
  }
}

.btns {
  display: flex;

  li {
    padding-bottom: 15px;
    flex: 1;
    text-align: center;
  }

  button {
    padding: 8px 20px;
    border: none;
    color: $light;
  }

  .close {
    background-color: $dark09;
  }

  .del {
    background-color: $assertive;
  }
}
</style>
